import {exerciseTypes} from '#/themes/classic-quiz/exerciseTypes'
import {type ThemePlugin} from '#/types/capsule'
import {EditorComponent} from './EditorComponent'
import {PlayerComponent} from './PlayerComponent'
import {settingsSchema} from './settingsSchema'

const summerTheme: ThemePlugin = {
  id: 'summer',
  name: 'Summer',
  version: '1.0.0',
  description: 'Bright and colorful summer vibes',
  previewColor: '#f59e0b',
  category: 'classic' as const,
  exerciseTypes,
  settingsSchema,
  PlayerComponent,
  EditorComponent,
  PreviewComponent: PlayerComponent,
}

export default summerTheme
